export class CarrierICDCodesClass {
  constructor(
    public Z8481 = false,
    public Z31430 = false,
    public Z31440 = false,
    public Z810 = false,
    public O285_carrier = false,
    public Z3481_carrier = false,
    public Z3482_carrier = false,
    public Z3483_carrier = false,
    public otherCarrierScreenICDCodes = "",
  ) {}
}
